interface LookupRequest {
  query: string;
  context: string;
  language: string;
  explanationLanguage: string;
}

const definitionCacheKey = (lookupRequest: LookupRequest) =>
  [
    lookupRequest.query,
    lookupRequest.context,
    lookupRequest.language,
    lookupRequest.explanationLanguage,
  ].join("\n");

const definitionCache: { [key: string]: string } = {};

export const cacheGet = (lookupRequest: LookupRequest) =>
  definitionCache[definitionCacheKey(lookupRequest)];

export const cacheSet = (lookupRequest: LookupRequest, definition: string) => {
  definitionCache[definitionCacheKey(lookupRequest)] = definition;
};
